var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.125C8.20304 5.125 5.125 8.20304 5.125 12C5.125 15.797 8.20304 18.875 12 18.875C15.797 18.875 18.875 15.797 18.875 12C18.875 8.20304 15.797 5.125 12 5.125ZM3.875 12C3.875 7.51269 7.51269 3.875 12 3.875C16.4873 3.875 20.125 7.51269 20.125 12C20.125 16.4873 16.4873 20.125 12 20.125C7.51269 20.125 3.875 16.4873 3.875 12Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.875C12.3452 3.875 12.625 4.15482 12.625 4.5V19.5C12.625 19.8452 12.3452 20.125 12 20.125C11.6548 20.125 11.375 19.8452 11.375 19.5V4.5C11.375 4.15482 11.6548 3.875 12 3.875Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5.78906C17.3452 5.78906 17.625 6.06888 17.625 6.41406V17.5859C17.625 17.9311 17.3452 18.2109 17 18.2109C16.6548 18.2109 16.375 17.9311 16.375 17.5859V6.41406C16.375 6.06888 16.6548 5.78906 17 5.78906Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 4.30469C14.8452 4.30469 15.125 4.58451 15.125 4.92969V19.0703C15.125 19.4155 14.8452 19.6953 14.5 19.6953C14.1548 19.6953 13.875 19.4155 13.875 19.0703V4.92969C13.875 4.58451 14.1548 4.30469 14.5 4.30469Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpacity);
export default __webpack_public_path__ + "static/media/opacity.e0f5d8bcfff4dc9b184c89bf3345f204.svg";
export { ForwardRef as ReactComponent };